module.exports = __webpack_public_path__ + "static/media/COS_COOPER_LIFESTYLES.991b06b2.png";